import { PAYMENT_METHOD_CODE, PAYMENT_METHOD_DETAILS } from "consts";
import { usePolicyDetail } from "data/ss-data-hooks";
import { acceptPaymentOnCancelledPolicy } from "utils";

export enum BILLING_STATES {
  cancelledPaymentDue,
  cancelled,
  paid,
  mortgageePastDue,
  mortgagee,
  directPastDue,
  easypayPastDue,
  directScheduled,
  easypayScheduled,
}

export const useBillingState = () => {
  const { data } = usePolicyDetail();

  const { accounting } = data?.userBilling ?? {};
  const { policyStateAttributes, policyStatus, currentTerm } =
    data?.userDetails ?? {};
  const { reasonCode = { value: "" } } = policyStateAttributes ?? {};
  const { effectiveDate: renewalDate = "" } = currentTerm ?? {};

  // Get policy's billing details:
  const currentPaymentMethod =
    PAYMENT_METHOD_DETAILS[accounting?.paymentPlan?.planType?.toLowerCase()]
      ?.paymentMethod ?? "";
  const isMortgagee = currentPaymentMethod.includes(
    PAYMENT_METHOD_CODE.INVOICE
  );
  const isDirect = currentPaymentMethod.includes(
    PAYMENT_METHOD_CODE.DIRECTBILL
  );
  const isEasypay = currentPaymentMethod.includes(PAYMENT_METHOD_CODE.EASYPAY);
  const isCancelled = policyStatus === "CANCELLEDPOLICY";
  const paymentDueAndCancelled = acceptPaymentOnCancelledPolicy(
    policyStatus,
    reasonCode?.value,
    renewalDate,
    accounting?.minimumPaymentDue,
    data?.userPolicyProperties.moratorium?.isUnderMoratorium
  );

  // Determine payment amount, due date, and if it is overdue.
  let [noUpcomingPayment, isOverduePayment] = [false, false];

  if (accounting?.dueDate === "No Upcoming Payment") {
    noUpcomingPayment = true;
  } else {
    isOverduePayment = Date.now() > Number(accounting?.dueDate);
  }

  if (isCancelled) {
    return paymentDueAndCancelled
      ? BILLING_STATES.cancelledPaymentDue
      : BILLING_STATES.cancelled;
  }

  let billingState: number = -1;
  if (isDirect) {
    billingState = isOverduePayment
      ? BILLING_STATES.directPastDue
      : noUpcomingPayment
      ? BILLING_STATES.paid
      : BILLING_STATES.directScheduled;
  }

  if (isEasypay) {
    billingState = isOverduePayment
      ? BILLING_STATES.easypayPastDue
      : noUpcomingPayment
      ? BILLING_STATES.paid
      : BILLING_STATES.easypayScheduled;
  }

  if (isMortgagee) {
    billingState = isOverduePayment
      ? BILLING_STATES.mortgageePastDue
      : BILLING_STATES.mortgagee;
  }

  return billingState;
};
